import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Reel } from "../GameComponents/Reel";
import { Symbol } from "../GameComponents/Symbol";

/**
 * Reel2 handles:
 * - z-order
 * - usage of Normal instead of Rotation
 */
@engineComponent(ComponentTypes.DisplayObject)
export class Reel2 extends Reel {
    //******************************************************************************************************************
    //  SHOW SYMBOLS, SPIN ROLL
    //******************************************************************************************************************

    public showSymbols(): void {
        super.showSymbols();

        this.moveToTop();
    }

    protected updateReel(): void {
        super.updateReel();

        this.moveToTop();
    }

    private moveToTop(): void {
        for (let i = 0; i < this.currentSymbols.length; i++) {
            const symbol = this.currentSymbols[i];

            if (symbol !== null && symbol.id === 10) {
                symbol.parent.addChild(symbol);
            }
        }

        for (let i = 0; i < this.currentSymbols.length; i++) {
            const symbol = this.currentSymbols[i];

            if (symbol !== null && symbol.id === 11) {
                symbol.parent.addChild(symbol);
            }
        }
    }

    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************

    protected getSymbol(symbolId: number, symbolCase: string): Symbol {
        if (symbolCase === Symbol.CaseRotation) {
            symbolCase = Symbol.CaseNormal;
        }

        return super.getSymbol(symbolId, symbolCase);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/Reel2.ts
 **/